import { useRef, useState, useCallback, useEffect } from 'react';
import { FormRenderer, Button } from 'components/generic';
import Images from 'assets/Images';
import classNames from 'classnames';
import { cloneDeep } from 'lodash';
import { AnimatePresence, motion } from 'framer-motion';

import './style.scss';

export default function Filter(props) {
	const { filterObj, handleSubmit, handleOnChangeVal, last, handleDropdownClick } = props;

	const [filterToggler, setFilterToggler] = useState();
	const [filterData, setFilterData] = useState();
	const buttonRef = useRef();
	const containerRef = useRef();

	const handleFilterToggler = () => {
		setFilterToggler(prevState => !prevState);
	};

	const displayContent = (
		<>
			<div className={`flex-end ${last && 'filter--last'}`}>
				<span ref={buttonRef}>
					<Button transparent label='Filters' compact handleOnSubmit={handleFilterToggler} _src={Images?.filter} />
				</span>
			</div>
		</>
	);

	const handleOnChange = obj => {
		setFilterData(prevState => {
			const data = cloneDeep(prevState);
			const item = data?.filter(el => el?.field_key === obj?.key)?.at();
			item && (item.value = obj.e);
			return data;
		});
	};

	const handleClear = () => {
		setFilterData(filterObj?.filter(el => el?.filterBy));
	};

	const handleSave = () => {
		const data = [];
		filterData?.map(el => ![null, undefined, '']?.includes(el?.value) && data.push({ id: el?.field_key, value: el?.value }));
		handleSubmit(data);
		handleFilterToggler();
	};

	useEffect(() => {
		setFilterData(filterObj?.filter(el => el?.filterBy));
	}, [filterObj]);

	// outside click handle function
	const handleClickOutside = useCallback(
		event => {
			if (buttonRef?.current && !buttonRef?.current?.contains(event?.target) && !containerRef?.current?.contains(event?.target)) {
				filterToggler && setFilterToggler(false);
			}
		},
		[setFilterToggler, filterToggler]
	);

	// outside click handler
	useEffect(() => {
		document.addEventListener('click', handleClickOutside, true);
		return () => {
			document.removeEventListener('click', handleClickOutside, true);
		};
	}, [filterToggler, handleClickOutside]);

	return (
		<>
			{displayContent}
			<AnimatePresence>
				{filterToggler && (
					<motion.div initial={{ y: -10, opacity: 0 }} animate={{ y: 0, opacity: 1 }} exit={{ y: -10, opacity: 0 }} transition={{ duration: 0.2 }} className={classNames({ filter: true })} ref={containerRef}>
						<div className='filter-item'>
							<FormRenderer formObj={filterData} handleDropdownClick={handleDropdownClick} handleOnChange={handleOnChange} handleOnChangeVal={handleOnChangeVal} />
						</div>
						<div className='filter-button'>
							<Button ghost primary xsmall label='Clear' handleOnSubmit={handleClear} />
							<Button primary compact label='Apply' handleOnSubmit={handleSave} />
						</div>
					</motion.div>
				)}
			</AnimatePresence>
		</>
	);
}
